// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__UYHPW","col":"styles_col__2WEzS"};